<template>
    <div style="overflow-x: auto;">
        <p>
            Action
            <b-select v-model="type" :options="[
                { text: 'Récupérer', value: 'récupérer' },
                { text: 'Mettre à jour', value: 'mettre à jour' },
                { text: 'Insérer', value: 'insérer' },
                { text: 'Requête', value: 'requête' },
                { text: 'Requête colonne', value: 'requête colonne' },
                { text: 'Requête unique', value: 'requête unique' }
            ]" />
        </p>

        <!-- Table selector (récupérer / mettre à jour / insérer) -->
        <p v-if="type === 'récupérer' || type === 'mettre à jour' || type === 'insérer'">
            Table
            <b-input :list="'tbl' + id" v-model="table" placeholder="Nom de la table" />
            <datalist :id="'tbl' + id">
                <option v-for="(t, ti) in (db_tables.length ? db_tables : tables)" :key="'tbl' + ti">{{ t }}</option>
            </datalist>
        </p>

        <!-- ===== RÉCUPÉRER ===== -->
        <div v-if="type === 'récupérer'">
            <p>
                Personnaliser select
                <b-input v-model="select" placeholder="ex: colonne1, colonne2" />
            </p>
            <p>
                Personnaliser fin de requête
                <b-input v-model="end" placeholder="ex: LIMIT 10" />
            </p>

            <b-button variant="link" class="p-0 mb-2 text-muted" @click="show_options_recup = !show_options_recup">
                Options <i :class="show_options_recup ? 'fas fa-minus' : 'fas fa-plus'"></i>
            </b-button>
            <b-collapse v-model="show_options_recup">
                <p>
                    <b-checkbox v-model="unique">Requête unique — exécuter une seule fois (pas ligne par ligne)</b-checkbox>
                </p>
                <p>
                    <b-checkbox v-model="in_memory">Aucune des colonnes de recherche n'est de type nombre</b-checkbox>
                </p>
                <p>
                    <b-checkbox v-model="null_as_string">Enregistrer les valeurs NULL comme la chaîne "null"</b-checkbox>
                </p>
                <p>
                    <b-checkbox v-model="date_strings">Dates au format SQL (2026-01-23 13:24:15) plutôt qu'ISO (2026-01-23T13:24:15.000Z)</b-checkbox>
                </p>
                <p class="mt-2">
                    Colonne de résultats
                    <b-input v-model="response_column" />
                </p>
            </b-collapse>

            <div class="mt-2">
                <strong>Recherche</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne db</b-th>
                            <b-th>Type</b-th>
                            <b-th>Comparaison</b-th>
                            <b-th>Valeur / Colonne CSV / Expression</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(row, idx) in colonnes_search" :key="'sr' + idx">
                            <b-td>
                                <b-input :list="'cs_col' + id" v-model="row.colonne" size="sm" />
                                <datalist :id="'cs_col' + id">
                                    <option v-for="(c, ci) in db_columns" :key="'csc' + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-select v-model="row.type" size="sm" :options="[
                                    { text: 'Valeur fixe', value: 'valeur' },
                                    { text: 'Colonne CSV', value: 'colonne' },
                                    { text: 'Expression', value: 'expression' }
                                ]" />
                            </b-td>
                            <b-td>
                                <b-select v-model="row.comparaison" size="sm" :options="comparaison_options" />
                            </b-td>
                            <b-td>
                                <template v-if="row.type === 'colonne'">
                                    <b-input :list="'cs_val' + id + idx" v-model="row.valeur" size="sm" :placeholder="row.colonne || 'nom de la colonne CSV'" />
                                    <datalist :id="'cs_val' + id + idx">
                                        <option v-for="(c, ci) in columns_data" :key="'csvc' + idx + ci">{{ c }}</option>
                                    </datalist>
                                </template>
                                <b-input v-else-if="row.type === 'expression'" v-model="row.valeur" size="sm" placeholder="${data.col1}_${data.col2}" />
                                <b-input v-else v-model="row.valeur" size="sm" placeholder="valeur littérale" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="colonnes_search.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="add_search_row">+ Ajouter une ligne</b-button>
            </div>
        </div>
        <div v-if="type === 'mettre à jour'">
            <p>
                <b-checkbox v-model="create">Créer la ligne si elle n'existe pas</b-checkbox>
            </p>

            <div class="mt-2">
                <strong>Mapping</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne db</b-th>
                            <b-th>Type</b-th>
                            <b-th>Source</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(row, idx) in colonnes_mapping" :key="'mp' + idx">
                            <b-td>
                                <b-input :list="'mp_db' + id + idx" v-model="row.mapping" size="sm" />
                                <datalist :id="'mp_db' + id + idx">
                                    <option v-for="(c, ci) in db_columns" :key="'mpdc' + idx + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-select v-model="row.type" size="sm" :options="[
                                    { text: 'Colonne CSV', value: 'colonne' },
                                    { text: 'Valeur fixe', value: 'valeur' },
                                    { text: 'Expression', value: 'expression' }
                                ]" />
                            </b-td>
                            <b-td>
                                <template v-if="!row.type || row.type === 'colonne'">
                                    <b-input :list="'mp_src' + id + idx" v-model="row.colonne" size="sm" />
                                    <datalist :id="'mp_src' + id + idx">
                                        <option v-for="(c, ci) in columns_data" :key="'mpsc' + idx + ci">{{ c }}</option>
                                    </datalist>
                                </template>
                                <b-input v-else-if="row.type === 'expression'" v-model="row.valeur" size="sm" placeholder="${data.col1}_${data.col2}" />
                                <b-input v-else v-model="row.valeur" size="sm" placeholder="valeur littérale" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="colonnes_mapping.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" variant="primary" @click="add_mapping_row">+ Ajouter une ligne</b-button>
                <b-button size="sm" variant="outline-secondary" class="ml-2" @click="confirm_mapping = 'reset'">&#8635; Réinitialiser</b-button>
                <b-button size="sm" variant="outline-danger" class="ml-1" @click="confirm_mapping = 'clear'">&#128465;</b-button>
                <div v-if="confirm_mapping" class="mt-2 p-2 border border-warning rounded">
                    <span v-if="confirm_mapping === 'clear'">Supprimer toutes les lignes du mapping ?</span>
                    <span v-else>Réinitialiser le mapping avec toutes les colonnes CSV ?</span>
                    <b-button size="sm" variant="danger" class="ml-2" @click="confirm_mapping === 'clear' ? (colonnes_mapping = [], confirm_mapping = null) : (reset_mapping(), confirm_mapping = null)">Confirmer</b-button>
                    <b-button size="sm" class="ml-1" @click="confirm_mapping = null">Annuler</b-button>
                </div>
            </div>

            <div class="mt-2">
                <strong>Colonnes uniques db</strong>
                <small class="text-muted d-block mb-1">Colonnes de la table db identifiant les doublons — si une ligne avec ces valeurs existe déjà, elle sera mise à jour plutôt qu'insérée</small>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne db</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(val, idx) in colonnes_unique" :key="'cu' + idx">
                            <b-td>
                                <b-input :list="'cu_col' + id" v-model="colonnes_unique[idx]" size="sm" />
                                <datalist :id="'cu_col' + id">
                                    <option v-for="(c, ci) in db_columns" :key="'cuc' + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="colonnes_unique.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="colonnes_unique.push('')">+ Ajouter une colonne unique</b-button>
            </div>

            <p class="mt-2">
                Colonne de résultats
                <b-input v-model="response_column" />
            </p>
        </div>

        <!-- ===== INSÉRER ===== -->
        <div v-if="type === 'insérer'">
            <div class="mt-2">
                <strong>Mapping</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne db</b-th>
                            <b-th>Type</b-th>
                            <b-th>Source</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(row, idx) in colonnes_mapping" :key="'ip' + idx">
                            <b-td>
                                <b-input :list="'ip_db' + id + idx" v-model="row.mapping" size="sm" />
                                <datalist :id="'ip_db' + id + idx">
                                    <option v-for="(c, ci) in db_columns" :key="'ipdc' + idx + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-select v-model="row.type" size="sm" :options="[
                                    { text: 'Colonne CSV', value: 'colonne' },
                                    { text: 'Valeur fixe', value: 'valeur' },
                                    { text: 'Expression', value: 'expression' }
                                ]" />
                            </b-td>
                            <b-td>
                                <template v-if="!row.type || row.type === 'colonne'">
                                    <b-input :list="'ip_src' + id + idx" v-model="row.colonne" size="sm" />
                                    <datalist :id="'ip_src' + id + idx">
                                        <option v-for="(c, ci) in columns_data" :key="'ipsc' + idx + ci">{{ c }}</option>
                                    </datalist>
                                </template>
                                <b-input v-else-if="row.type === 'expression'" v-model="row.valeur" size="sm" placeholder="${data.col1}_${data.col2}" />
                                <b-input v-else v-model="row.valeur" size="sm" placeholder="valeur littérale" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="colonnes_mapping.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="add_mapping_row">+ Ajouter une ligne</b-button>
                <b-button size="sm" variant="outline-secondary" class="ml-2" @click="confirm_mapping = 'reset'">&#8635; Réinitialiser</b-button>
                <b-button size="sm" variant="outline-danger" class="ml-1" @click="confirm_mapping = 'clear'">&#128465;</b-button>
                <div v-if="confirm_mapping" class="mt-2 p-2 border border-warning rounded">
                    <span v-if="confirm_mapping === 'clear'">Supprimer toutes les lignes du mapping ?</span>
                    <span v-else>Réinitialiser le mapping avec toutes les colonnes CSV ?</span>
                    <b-button size="sm" variant="danger" class="ml-2" @click="confirm_mapping === 'clear' ? (colonnes_mapping = [], confirm_mapping = null) : (reset_mapping(), confirm_mapping = null)">Confirmer</b-button>
                    <b-button size="sm" class="ml-1" @click="confirm_mapping = null">Annuler</b-button>
                </div>
            </div>

            <div class="mt-2">
                <strong>Colonnes uniques db</strong>
                <small class="text-muted d-block mb-1">Colonnes de la table db identifiant les doublons — si une ligne avec ces valeurs existe déjà, elle sera ignorée</small>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Colonne db</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(val, idx) in colonnes_unique" :key="'iu' + idx">
                            <b-td>
                                <b-input :list="'iu_col' + id" v-model="colonnes_unique[idx]" size="sm" />
                                <datalist :id="'iu_col' + id">
                                    <option v-for="(c, ci) in db_columns" :key="'iuc' + ci">{{ c }}</option>
                                </datalist>
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="colonnes_unique.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="colonnes_unique.push('')">+ Ajouter une colonne unique</b-button>
            </div>

            <p class="mt-2">
                Colonne de résultats
                <b-input v-model="response_column" />
            </p>
        </div>

        <!-- ===== REQUÊTE ===== -->
        <div v-if="type === 'requête'">
            <p><strong>Requête SQL</strong></p>
            <ace_editor ref="ace_requete" mode="sql" :height="200" />
            <p>
                Colonne de résultats
                <b-input v-model="response_column" />
            </p>
            <div class="mt-2">
                <strong>Documentation — tables pouvant être modifiées</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Table</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(val, idx) in doc_table_possibilities" :key="'dtp' + idx">
                            <b-td>
                                <b-input v-model="doc_table_possibilities[idx]" size="sm" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="doc_table_possibilities.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="doc_table_possibilities.push('')">+ Ajouter une table</b-button>
            </div>
        </div>

        <!-- ===== REQUÊTE COLONNE ===== -->
        <div v-if="type === 'requête colonne'">
            <p>
                Colonne
                <b-input :list="'rqc_col' + id" v-model="colonne" />
                <datalist :id="'rqc_col' + id">
                    <option v-for="(c, ci) in columns_data" :key="'rqcc' + ci">{{ c }}</option>
                </datalist>
            </p>
            <p>
                Colonne de résultats
                <b-input v-model="response_column" />
            </p>
            <div class="mt-2">
                <strong>Documentation — tables pouvant être modifiées</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Table</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(val, idx) in doc_table_possibilities" :key="'dtpc' + idx">
                            <b-td>
                                <b-input v-model="doc_table_possibilities[idx]" size="sm" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="doc_table_possibilities.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="doc_table_possibilities.push('')">+ Ajouter une table</b-button>
            </div>
        </div>

        <!-- ===== REQUÊTE UNIQUE ===== -->
        <div v-if="type === 'requête unique'">
            <p><strong>Requête SQL</strong></p>
            <ace_editor ref="ace_requete_unique" mode="sql" :height="200" />
            <div class="mt-2">
                <strong>Documentation — tables pouvant être modifiées</strong>
                <b-table-simple small bordered class="mt-1">
                    <b-thead>
                        <b-tr>
                            <b-th>Table</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(val, idx) in doc_table_possibilities" :key="'dtpu' + idx">
                            <b-td>
                                <b-input v-model="doc_table_possibilities[idx]" size="sm" />
                            </b-td>
                            <b-td>
                                <b-button size="sm" variant="danger" @click="doc_table_possibilities.splice(idx, 1)">✕</b-button>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-button size="sm" @click="doc_table_possibilities.push('')">+ Ajouter une table</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
    import ace_editor from "../ace_editor.vue";

    export default {
        name: "base_de_donnees",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            tables: { default: () => [] },
            db_schema: { default: () => ({}) },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        computed: {
            db_columns() {
                if (this.table && this.db_schema && this.db_schema[this.table])
                    return this.db_schema[this.table];
                return [];
            },
            db_tables() {
                return Object.keys(this.db_schema || {});
            }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            // Quand le schéma DB arrive après le chargement de la table
            db_columns(newCols) {
                if (newCols.length > 0 && this.colonnes_mapping.length === 0 && this._waiting_schema)
                    this.init_from_prev_data();
                this._waiting_schema = false;
            },
            table(newVal) {
                if (!this._table_just_loaded && newVal &&
                    (this.type === 'mettre à jour' || this.type === 'insérer')) {
                    if (this.colonnes_mapping.length === 0) {
                        // Mapping vide : remplir automatiquement si schéma disponible
                        if (this.db_columns.length > 0)
                            this.init_from_prev_data();
                        else
                            this._waiting_schema = true; // schéma pas encore chargé, attendre db_columns
                    }
                    // Si mapping non vide : ne rien faire, l'utilisateur utilise "Réinitialiser"
                }
            },
            type(newType) {
                this.$nextTick(() => {
                    if (newType === "requête" && this.$refs.ace_requete)
                        this.$refs.ace_requete.load(this.requete);
                    if (newType === "requête unique" && this.$refs.ace_requete_unique)
                        this.$refs.ace_requete_unique.load(this.requete);
                });
            }
        },
        components: { ace_editor },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                // Type d'action
                type: "récupérer",

                // Champs communs cachés
                token: "",
                mysql2: false,

                // Champs partagés
                table: "",
                response_column: "response",

                // Récupérer
                select: "",
                end: "",
                unique: false,
                in_memory: false,
                null_as_string: false,
                date_strings: true,
                colonnes_search: [],

                // Mettre à jour / Insérer
                create: true,
                colonnes_mapping: [],
                colonnes_unique: [],
                confirm_mapping: null, // 'clear' | 'reset' | null

                show_options_recup: false,

                // Requête / Requête unique
                requete: "",

                // Requête colonne
                colonne: "",

                // Doc tables
                doc_table_possibilities: [],

                comparaison_options: [
                    "est égal à",
                    "est différent de",
                    "contient",
                    "ne contient pas",
                    "plus petit",
                    "plus petit ou égal",
                    "plus grand",
                    "plus grand ou égal"
                ]
            };
        },
        methods: {
            add_search_row() {
                this.colonnes_search.push({
                    colonne: "",
                    type: "valeur",
                    comparaison: "est égal à",
                    valeur: ""
                });
            },
            add_mapping_row() {
                this.colonnes_mapping.push({ colonne: "", mapping: "", type: "colonne", valeur: "" });
            },
            reset_mapping() {
                var db_cols = this.db_columns;
                var csv_cols = this.columns_data;
                if (db_cols.length > 0) {
                    this.colonnes_mapping = db_cols
                        .filter(c => csv_cols.includes(c))
                        .map(c => ({ colonne: c, mapping: c, type: "colonne", valeur: "" }));
                } else {
                    this.colonnes_mapping = csv_cols.map(c => ({
                        colonne: c, mapping: c, type: "colonne", valeur: ""
                    }));
                }
            },
            save() {
                var base = {
                    token: (this.client && this.client.details && this.client.details.database_token)
                        ? this.client.details.database_token
                        : (this.token || ""),
                    mysql2: this.mysql2 || false,
                    type: this.type
                };

                switch (this.type) {
                    case "récupérer":
                        return Object.assign({}, base, {
                            table: this.table,
                            select: this.select,
                            end: this.end,
                            unique: this.unique,
                            in_memory: this.in_memory,
                            null_as_string: this.null_as_string,
                            date_strings: this.date_strings,
                            colonnes: this.colonnes_search,
                            response_column: this.response_column
                        });
                    case "mettre à jour":
                        return Object.assign({}, base, {
                            table: this.table,
                            create: this.create,
                            colonnes: this.colonnes_mapping,
                            colonnes_unique: this.colonnes_unique,
                            response_column: this.response_column
                        });
                    case "insérer":
                        return Object.assign({}, base, {
                            table: this.table,
                            colonnes: this.colonnes_mapping,
                            colonnes_unique: this.colonnes_unique,
                            response_column: this.response_column
                        });
                    case "requête":
                        return Object.assign({}, base, {
                            requete: this.$refs.ace_requete ? this.$refs.ace_requete.save() : this.requete,
                            in_memory: this.in_memory,
                            response_column: this.response_column,
                            doc_table_possibilities: this.doc_table_possibilities
                        });
                    case "requête colonne":
                        return Object.assign({}, base, {
                            colonne: this.colonne,
                            in_memory: this.in_memory,
                            response_column: this.response_column,
                            doc_table_possibilities: this.doc_table_possibilities
                        });
                    case "requête unique":
                        return Object.assign({}, base, {
                            requete: this.$refs.ace_requete_unique ? this.$refs.ace_requete_unique.save() : this.requete,
                            in_memory: this.in_memory,
                            doc_table_possibilities: this.doc_table_possibilities
                        });
                    default:
                        return base;
                }
            },
            init_from_prev_data() {
                if (!this.columns_data.length) return;

                // Pré-remplit le mapping (mettre à jour / insérer)
                // Si db_schema disponible : seules les colonnes db présentes aussi dans le CSV
                // Sinon : repli sur les colonnes CSV uniquement (si mapping encore vide)
                var db_cols = this.db_columns;
                var csv_cols = this.columns_data;
                var columns_mapping = [];

                if (db_cols.length > 0) {
                    for (var i = 0; i < db_cols.length; i++) {
                        if (csv_cols.includes(db_cols[i])) {
                            columns_mapping.push({
                                mapping: db_cols[i],
                                colonne: db_cols[i],
                                type: "colonne",
                                valeur: ""
                            });
                        }
                    }
                    this.colonnes_mapping = columns_mapping;
                    this._csv_init = false;
                } else if (csv_cols.length > 0 && this.colonnes_mapping.length === 0) {
                    for (var i = 0; i < csv_cols.length; i++) {
                        columns_mapping.push({
                            colonne: csv_cols[i],
                            mapping: csv_cols[i],
                            type: "colonne",
                            valeur: ""
                        });
                    }
                    this.colonnes_mapping = columns_mapping;
                    this._csv_init = true;
                }
            },
            async load(data) {
                if (!data) return;

                this.type = data.type || "récupérer";
                this.token = data.token || "";
                this.mysql2 = data.mysql2 || false;
                this.table = data.table || "";
                this.response_column = data.response_column || "response";
                this.select = data.select || "";
                this.end = data.end || "";
                this.unique = data.unique || false;
                this.in_memory = data.in_memory || false;
                this.null_as_string = data.null_as_string || false;
                this.date_strings = data.hasOwnProperty('date_strings') ? data.date_strings : (data.type ? false : true);
                this.create = data.create !== undefined ? data.create : true;
                this.requete = data.requete || "";
                this.colonne = data.colonne || "";
                this.doc_table_possibilities = data.doc_table_possibilities || [];

                this.$nextTick(() => {
                    if (this.type === "requête" && this.$refs.ace_requete)
                        this.$refs.ace_requete.load(this.requete);
                    if (this.type === "requête unique" && this.$refs.ace_requete_unique)
                        this.$refs.ace_requete_unique.load(this.requete);
                });

                if (this.type === "récupérer") {
                    this.colonnes_search = (data.colonnes && data.colonnes.length > 0)
                        ? data.colonnes.filter(r => r.type)  // exclure les anciennes lignes type="" (inactives)
                        : [];
                } else if (this.type === "mettre à jour" || this.type === "insérer") {
                    this.colonnes_mapping = (data.colonnes && data.colonnes.length > 0)
                        ? data.colonnes.map(r => ({ ...r, type: r.type || "colonne" }))
                        : [];
                    this.colonnes_unique = data.colonnes_unique || [];
                    this._csv_init = false;
                    this._table_just_loaded = true;
                    this.$nextTick(() => { this._table_just_loaded = false; });
                }
            }
        },
        mounted() {
            // Ne pas pré-remplir au montage : l'init se fait à la sélection de table
        }
    }
</script>

<style scoped>
</style>
